<div style="display: flex; height: 100%" class="text-center auth-page">
  <main class="form-signin">
    <form
      #loginForm="ngForm"
      (ngSubmit)="
        isResetingPass
          ? isOtpSent
            ? verifyOtpResetPass(loginForm)
            : sendOtp(loginForm)
          : login(loginForm)
      "
    >
      <!-- <img class="mb-3" width="40%" src="../../assets/brand-logo.jpeg" /> -->

      <div class="form-floating">
        <input
          #emailInput="ngModel"
          type="email"
          name="email"
          email
          [(ngModel)]="userLogin.email"
          class="form-control"
          placeholder="name@example.com"
        />
        <label for="floatingInput">Email address</label>
        <div *ngIf="emailInput.invalid">Email is required</div>
      </div>

      <div class="form-floating" *ngIf="isOtpSent">
        <input
          #otpInput="ngModel"
          type="text"
          name="otp"
          class="form-control"
          ngModel
          placeholder="Enter OTP"
        />
        <label for="floatingOtp">OTP</label>
        <div *ngIf="otpInput.invalid">OTP is required</div>
      </div>

      <div class="form-floating" *ngIf="!isResetingPass || isOtpSent">
        <input
          #passInput="ngModel"
          type="password"
          name="password"
          class="form-control"
          ngModel
          placeholder="Password"
        />
        <label for="floatingPassword">Password</label>
        <div *ngIf="passInput.invalid">Password is required</div>
      </div>

      <div
        style="
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          padding-top: 22px;
        "
      >
        <button
          type="button"
          class="btn btn-warning"
          (click)="
            isResetingPass = !isResetingPass;
            isOtpSent ? (isOtpSent = !isOtpSent) : null
          "
        >
          {{ !isResetingPass ? 'Forgot password' : 'Cancel' }}
        </button>
        <app-loading-btn
          [isLoading]="isLoading"
          [btnName]="
            isResetingPass
              ? isOtpSent
                ? 'Reset Password'
                : 'Send OTP'
              : 'Sign in'
          "
          [disabled]="loginForm.invalid"
        ></app-loading-btn>
      </div>
      <br />
      <p class="mt-5 mb-3 text-white">
        Web App Ver {{ AppVer }}
        <br />
        &copy; {{ currentYear }} | Cosmica Telematics
      </p>
    </form>
  </main>
</div>
